import { IconTickWave } from '@medifind/icons';
import { What } from '@medifind/shared-basic-components';
import styles from './ClaimedProfileBadge.module.scss';

const ClaimedProfileBadge = ({ doctor, position = 'top' }) => {
  if (!doctor) return;

  const { profileClaimed, isPremium } = doctor;

  if (!profileClaimed && !isPremium) return;

  return (
    <What icon={<IconTickWave />} classes={styles} position={position}>
      <p>
        {profileClaimed
          ? 'This profile has been claimed, which allows the provider or their staff to update or verify the information displayed.'
          : 'This profile has been verified.'}
      </p>
    </What>
  );
};

export { ClaimedProfileBadge as default, ClaimedProfileBadge };
